module.exports = __webpack_public_path__ + "static/media/monthly-price.740aaf53.svg";